import { homepageSlice } from '@app/state/slices/homepage/homepage.slice';
import { getSectionData } from '@app/state/slices/homepage/homepage.thunks';

export const homepageActions = {
    ...homepageSlice.actions,
    getSectionData,
};
